import * as React from "react";
import { useRef } from "react";
import {
  // useFindOffers,
  useFindAllCategories,
  SearchOffers,
  useMyIdentities,
  MyAppSettingController,
  useFindAllLocations
} from "@njoy/controller";

import { TemplateSub } from "../../../components/layouts/TemplateSub";
import { LocationFilterModal } from "../../../components/modals/locationFilterModal";
import { OfferCountdownCard } from "../../../components/cards/OfferCountdownCard";

import searchIcon from "../../../assets/discovery/search-icon.png";
import filterLocationIcon from "../../../assets/discovery/filter-horizontal.png";
import SearchInput from "../../../components/uiMerge/searchInput";
import NoticeBox from "../../../components/noticeBox/NoticeBox";
import OfferCardSkeleton from "../../../components/cards/OfferCardSkeleton";
import Button from "../../../components/uiMerge/newButton";
import PageLoader from "src/modules/shared/PageLoader";

export const FindOffersConnector: React.FC = () => {
  const loadMoreRef = useRef<HTMLDivElement>(null);
  const [currentPage, setCurrentPage] = React.useState<string>("all");
  const [isSearchClicked, setIsSearchClicked] = React.useState(false);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [openLocationFilter, setOpenLocationFilter] = React.useState(false);
  const [filterByType, setFilterByType] = React.useState<string>("");
  const [filterByCommunity, setFilterByCommunity] = React.useState<string>("");
  const [filterByLocationId, setFilterByLocationId] = React.useState<string>("");
  const [isLoadingMore, setIsLoadingMore] = React.useState(false);
  const [endingSoon, setEndingSoon] = React.useState<boolean>(false);

  // const { offers = [] } = useFindOffers();
  const { locations, loading: locationLoading } = useFindAllLocations();
  const { categories = [] } = useFindAllCategories();
  const { myIdentities } = useMyIdentities({
    offset: 0,
    limit: 10
  });

  const resetLocationFilter = () => {
    setSearchTerm("");
    setFilterByType("");
    setFilterByLocationId("");
    setEndingSoon(false);
    setFilterByCommunity("");
  };

  return (
    <MyAppSettingController>
      {({ data, loading }) => {
        if (loading) {
          return (
          <PageLoader/>
          );
        }

        const currentLocationId = data?.myAppSetting?.location?.id || "";

        return (
          <TemplateSub
            isCentered={true}
            hasComponent
            component={
              <SearchInput
                prefixIcon={
                  <img src={searchIcon} alt="search" width={20} height={20} />
                }
                onClick={() => setIsSearchClicked(true)}
                id="search"
                name="search"
                type="search"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="max-[415px]:w-[280px] max-[390px]:w-[250px] max-[376px]:w-[235px] max-[361px]:w-[240px] max-[435px]:w-[290px] w-[310px] h-11 flex items-center gap-3 mt-0"
                end2end={true}
              />
            }
            page={`All Perks`}
            icon={
              <div
              className="flex items-center justify-center cursor-pointer w-11 h-11 rounded-md bg-[#404040] mt-1"
              onClick={() => setOpenLocationFilter(true)}>
                <img
                src={filterLocationIcon}
                alt=""
                height={20}
                width={20}
                className="cursor-pointer" />
              </div>
            }
          >
            <SearchOffers
              variables={{
                input: {
                  searchText: searchTerm,
                  filterByType,
                  filterByCommunity,
                  filterByLocationId:
                    filterByLocationId === ""
                      ? currentLocationId
                      : filterByLocationId,
                  endingSoon,
                },
                offset: 0,
                limit: 10,
              }}
            >
              {({
                offers: searchOffers,
                hasMoreOffers,
                loading: searchLoading,
                loadMore,
              }) => {
                const effectiveLocationId =
                  filterByLocationId === "" ? currentLocationId : filterByLocationId;
                const selectedLocation = locations.find(
                  (location: any) => location.id === effectiveLocationId
                );
                const selectedCommunity = myIdentities.find(
                  (identity: any) => identity?.community?.id === filterByCommunity
                );
                const filteredSearchOffers = (searchOffers || []).filter(
                  (offer) => currentPage === "all" || offer.category?.name === currentPage
                );
                const emptyStateFilters = [
                  selectedLocation?.city ? `this location` : null,
                  filterByType ? `offer type` : null,
                  selectedCommunity?.community?.alias
                    ? `community`
                    : null,
                  currentPage !== "all" ? `or category` : null,
                ].filter(Boolean);
                const emptyStateMessage = emptyStateFilters.length
                  ? `No offers are available for ${emptyStateFilters.join(", ")}.`
                  : "No offers match this filter at the moment.";

                return (
                  <div className="w-full flex-1 h-full overflow-y-auto pb-10">
                    <div
                      className={`overflow-x-auto flex gap-2 justify-start items-center transition-all duration-500 ease-in-out ${
                        isSearchClicked
                          ? "max-h-20 opacity-100 mb-4"
                          : "max-h-0 opacity-0 overflow-hidden"
                      }`}
                    >
                      <div
                        key="all"
                        className={`text-[10px] shadow py-3 px-7 rounded-[10px] text-white cursor-pointer transition duration-300 ${
                          currentPage === "all"
                            ? " bg-[linear-gradient(270deg,var(--brand-gradient-from)_0%,var(--brand-gradient-to)_98.3%)] font-semibold"
                            : "bg-[#3C3E58]"
                        }`}
                        onClick={() => setCurrentPage("all")}
                      >
                        <p className="text-sm truncate">All</p>
                      </div>
                      {categories.map((c) => (
                        <div
                          key={c.id}
                          className={`text-[10px] shadow py-3 px-7 rounded-[10px] text-white cursor-pointer transition duration-300 ${
                            currentPage === c.name
                              ? " bg-[linear-gradient(270deg,var(--brand-gradient-from)_0%,var(--brand-gradient-to)_98.3%)] font-semibold"
                              : "bg-[#3C3E58]"
                          }`}
                          onClick={() => setCurrentPage(c.name)}
                        >
                          <p className="text-sm truncate">{c.name}</p>
                        </div>
                      ))}
                    </div>

                    <div className="px-[1rem] mt-[40px] overflow-y-scroll mb-[20px]">
                      {searchLoading ? (
                        <div className="flex flex-wrap gap-[24px]">
                          <div className="max-w-[222px]"><OfferCardSkeleton /></div>
                          <div className="max-w-[222px]"><OfferCardSkeleton /></div>
                          <div className="max-w-[222px]"><OfferCardSkeleton /></div>
                        </div>
                      ) : 
                      !filteredSearchOffers.length ? (
                        <div className="grid gap-4">
                          <NoticeBox message={emptyStateMessage} />
                        </div>
                      ) : (
                        <>
                          <div ref={loadMoreRef} className="grid grid-cols-2 gap-4">
                            {filteredSearchOffers.map((c) => (
                                <div key={c.id} data-offer-card>
                                  <OfferCountdownCard offer={c}  />
                                </div>
                              ))}
                          </div>

                          {hasMoreOffers && (
                            <div className="flex justify-center mt-5">
                              <Button
                              className="bg-blue-600 mb-10 text-white !text-[14px] px-3 py-1 rounded"
                               onClick={async () => {
                                  setIsLoadingMore(true);
                                  const previousCount = searchOffers.length;
                                  await loadMore();
                                  setIsLoadingMore(false);

                                  const pollForNewItems = () => {
                                    const currentItems = loadMoreRef.current?.parentElement?.querySelectorAll('[data-offer-card]');
                                    if (currentItems && currentItems.length > previousCount && !isLoadingMore) {
                                      requestAnimationFrame(() => {
                                        requestAnimationFrame(() => {
                                          loadMoreRef.current?.scrollIntoView({
                                            behavior: "smooth",
                                            block: "end",
                                          });
                                        });
                                      });
                                    } else {
                                      setTimeout(pollForNewItems, 50);
                                    }
                                  };
                                  pollForNewItems();
                                }}
                              disabled={loading}>
                                Load More
                              </Button>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                );
              }}
            </SearchOffers>

            <LocationFilterModal
              isOpen={openLocationFilter}
              setIsOpen={setOpenLocationFilter}
              onClose={() => setOpenLocationFilter(false)}
              setFilterByType={setFilterByType}
              setFilterByCommunity={setFilterByCommunity}
              setFilterByLocationId={setFilterByLocationId}
              setEndingSoon={setEndingSoon}
              locations={locations}
              locationLoading={locationLoading}
              resetLocationFilter={resetLocationFilter}
              communities={myIdentities}
            />
          </TemplateSub>
        );
      }}
    </MyAppSettingController>
  );
};
